
import { defineComponent } from "vue";

export default defineComponent({
  name: "kt-events",
  components: {},
});
